import * as icons from "@qhealth-design-system/core/src/utils/icons.js";

// Adding ES module initialisation for components
export default function initComponents() {
  document.addEventListener("DOMContentLoaded", () => {
    // Look for any material icons needed for facility map component
    const shouldCallMaterialIconLoader = document.querySelectorAll(
      ".qld__card__action .material-symbols-rounded",
    );

    if (shouldCallMaterialIconLoader.length) {
      icons.loadMaterialIconSheet();
    }
  });
}
